import { useGetShipmentFieldsVisibility } from './use-get-shipment-fields-visibility';

export const useShipmentFieldsVisibility = (columnKey: string): boolean | 'PROGRESSING' => {
  const { data = {}, isLoading } = useGetShipmentFieldsVisibility();

  return isLoading ? 'PROGRESSING' : !!data?.[columnKey];
};
